const isNil = (value) => value === undefined || value === null;
const sameId = (a, b) => !isNil(a) && !isNil(b) && String(a) === String(b);

const parentIdOf = (realm) => {
  if (!realm) return undefined;
  if (!isNil(realm.parentId) && realm.parentId !== '') return realm.parentId;
  const parent = realm.parent;
  if (parent && typeof parent === 'object' && !isNil(parent.id)) return parent.id;
  return undefined;
};

// Explicit realms whose parent chain reaches the user's builder.
// A division belongs when its parentId is that builder; deeper realms belong
// when an ancestor in this same list does.
export const explicitRealmsBelongingToBuilder = (explicitRealms = [], builderRealm) => {
  const builderId = builderRealm && builderRealm.id;
  if (isNil(builderId)) return [];

  const byId = new Map();
  explicitRealms.forEach((realm) => {
    if (realm && !isNil(realm.id)) byId.set(String(realm.id), realm);
  });

  const belongs = (realm, seen) => {
    if (!realm || isNil(realm.id) || seen.has(String(realm.id))) return false;
    seen.add(String(realm.id));
    if (sameId(realm.id, builderId)) return true;

    const parentId = parentIdOf(realm);
    if (isNil(parentId)) return false;
    if (sameId(parentId, builderId)) return true;

    const parent = byId.get(String(parentId));
    return parent ? belongs(parent, seen) : false;
  };

  return explicitRealms.filter((realm) => belongs(realm, new Set()));
};
